import { LeMagFeaturedArticle } from "../LeMagArticle";

export class MockLeMagFeaturedArticle implements LeMagFeaturedArticle {
  private static INDEX = 0;
  public type: "game" | "article" = "game";
  public game_id: string;
  public title = "";
  public description = "";
  public tile_color = "";
  public image_16by9 = "";
  public image_16by9_md = "";
  public image_16by9_sm = "";
  public image_1by1 = "";
  public image_1by1_md = "";
  public image_1by1_sm = "";
  public slug = "";

  constructor() {
    MockLeMagFeaturedArticle.INDEX++;
    this.game_id = `${MockLeMagFeaturedArticle.INDEX}`;
    this.title = `title#${MockLeMagFeaturedArticle.INDEX}`;
  }
}
